import { TextBox } from './TextBox';

interface EmailBoxProps {
    id?: string;
    dataTestid?: string;
    value: string;
    name?: string;
    readOnly?: boolean;
    disabled?: boolean;
    label?: string;
    helperText?: string;
    required?: boolean;
    children?: React.ReactNode;
    width?: string;
    maxLength?: number;
    onChange: (value: string) => void;
    onEnterKey?: () => void;
    onValidationEvent?: (isValid: boolean) => void;
}

export const EmailBox: React.FC<EmailBoxProps> = ({
    id,
    dataTestid,
    value,
    readOnly = false,
    disabled,
    label,
    helperText,
    required = false,
    children,
    width = 'auto',
    maxLength,
    onChange,
    onEnterKey,
    onValidationEvent,
}) => {
    const validateValue = (value: string) => {
        if (required || (!required && value)) {
            const emailPattern = /^(?=.{1,255}$)[a-zA-Z0-9+._-]+@[a-zA-Z0-9+.-]+\.[a-zA-Z]{2,}$/;
            return emailPattern.test(value);
        }
        return true;
    };

    return (
        <TextBox
            id={id}
            dataTestid={dataTestid}
            value={value}
            onEnterKey={onEnterKey}
            readOnly={readOnly}
            disabled={disabled}
            onChange={onChange}
            validateValue={validateValue}
            onValidationEvent={onValidationEvent}
            validateValueMessage='Invalid email address'
            label={label}
            helperText={helperText}
            required={required}
            children={children}
            width={width}
            maxLength={maxLength}
            type='email'
        />
    );
};
